export default "__VITE_ASSET__470c1745__"